import type { AssetPageMapProps } from "./asset-page-map.type";

import { MapInteractive } from "@/modules/map";

import { useAssetPageMap } from "./asset-page-map.hook";

const AssetPageMap = ({ asset, isLoading }: AssetPageMapProps) => {
  const { mapId, markers, loading } = useAssetPageMap(asset);

  return (
    <MapInteractive
      id={mapId}
      sizes={{ windowHeightCoef: 2.5 }}
      markers={markers}
      loading={loading || isLoading}
      fitBoundsPadding={120}
    />
  );
};

export default AssetPageMap;
